module.exports = __webpack_public_path__ + "static/media/IMG-4.672b7b54.jpg";